import { z } from "zod";
import { Org } from "./Org";

export enum BookmarkType {
  AudienceBuilder = "audience-builder",
  TvRating = "tv-rating",
  HispanicRating = "hispanic-rating",
  ReachAndFrequencyV2 = "reach-and-frequency-v2",
  PoliticalPaidMedia = "political-paid-media",
}

export const zBookmark = z.object({
  app_client_id: z.number().nullish(),
  created_at: z.string(),
  deleted: z.boolean(),
  id: z.number(),
  meta_data: z.record(z.unknown()),
  org_id: z.number().nullish(),
  shared_with: z.array(z.number()),
  type: z.nativeEnum(BookmarkType),
  updated_at: z.string(),
  user: z.object({
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
  }),
  user_id: z.number(),
});

export type Bookmark = z.infer<typeof zBookmark> & {
  app_client?: { id: number; name: string };
  org?: Org;

  // added client side
  audiences?: string[];
  full_name?: string;
  geos?: string[];
};
